import magnifiAPIInstance from "./apiInstance";

export const showAPIs = {
  getShows: ({ payload }) => magnifiAPIInstance.post(`shows/get`, payload),
  deleteShow: ({ payload }) => magnifiAPIInstance.post(`shows/delete`, payload),
  createShow: ({ payload }) => magnifiAPIInstance.post(`shows/create`, payload),
  updateShow: ({ payload }) => magnifiAPIInstance.post(`shows/edit`, payload),
};
